import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'transformObject'
})
export class TransformObjectPipe implements PipeTransform {

  transform(value: any, keysTransform: string[]): any {
    if (value instanceof Array) {
      return value.map(val => this.objectTransform(val, keysTransform));
    }
    return this.objectTransform(value, keysTransform);
  }

  public objectTransform(object, keysTransform: string[]) {
    if (!object || typeof object !== 'object') {
      return object;
    }

    return keysTransform?.reduce((accum, key) => {
      accum[key] = object[key];
      return accum;
    }, { }) || object;
  }
}

